import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import { colors } from "~/_variables";

export default function about() {
  const heading = SplitText.create(".section-about .heading", {
    type: "chars",
  });
  const sub = SplitText.create(".section-about .headline .sub", {
    type: "chars",
  });

  heading.chars.forEach((char, i) => {
    gsap.set(char, { color: colors[i % 7] });
  });
  sub.chars.forEach((char, i) => {
    gsap.set(char, { color: colors[i % 7] });
  });

  return gsap
    .timeline()
    .from(
      heading.chars,
      {
        autoAlpha: 0,
        duration: 0.2,
        ease: "none",
        stagger: {
          amount: 0.3,
        },
      },
      "<"
    )
    .to(
      heading.chars,
      {
        color: "#ffffff",
        duration: 0.2,
        ease: "none",
        stagger: {
          amount: 0.3,
        },
      },
      "<0.3"
    )
    .from(
      sub.chars,
      {
        autoAlpha: 0,
        duration: 0.2,
        ease: "none",
        stagger: {
          amount: 0.5,
        },
      },
      "<"
    )
    .to(
      sub.chars,
      {
        color: "#1a1a1a",
        duration: 0.2,
        ease: "none",
        stagger: {
          amount: 0.5,
        },
      },
      "<0.3"
    )
    .from(
      ".section-about .intro__heading",
      {
        y: 75,
        autoAlpha: 0,
        ease: "expo.out",
        duration: 1.2,
      },
      "<"
    )
    .from(
      ".section-about .intro__paragraph",
      {
        y: 75,
        autoAlpha: 0,
        ease: "expo.out",
        duration: 1.2,
      },
      "<0.2"
    )
    .from(
      ".section-about .more",
      {
        y: 75,
        autoAlpha: 0,
        ease: "expo.out",
        duration: 1.2,
      },
      "<0.4"
    );
}
